// HelloWorld.js
import React from 'react';

const HelloWorld = ({ message }) => <div>{message || 'Hello World!'}</div>;

export default HelloWorld;
